export const PRIVATE_ENDPOINT_SERVICE_API_BASE_URL =
  '/private-endpoint-service-api';

export const PRIVATE_ENDPOINTS_BASE_URL = '/private-endpoints-overview';
